/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import RegimenChecklistItem from './regimen-checklist-item';
import RegimenChecklistItemDetail from './regimen-checklist-item-detail';
import RegimenChecklistItemUpdate from './regimen-checklist-item-update';
import RegimenChecklistItemDeleteDialog from './regimen-checklist-item-delete-dialog';

const RegimenChecklistItemRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<RegimenChecklistItem />} />
    <Route path="new" element={<RegimenChecklistItemUpdate />} />
    <Route path=":id">
      <Route index element={<RegimenChecklistItemDetail />} />
      <Route path="edit" element={<RegimenChecklistItemUpdate />} />
      <Route path="delete" element={<RegimenChecklistItemDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default RegimenChecklistItemRoutes;
